<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('anniversaries')">Anniversary Message</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.anniversary }} months
    </h1>
    <trashed-message v-if="anniversary.deleted_at" class="mb-6" @restore="restore">
      This anniversary message has been deleted.
    </trashed-message>
    <badge-preview :preview_anniversary=form.anniversary :preview_message=form.message />
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.anniversary" class="pr-6 pb-8 w-full" label="Twitch Anniversary" :error="this.$page.props.errors.anniversary"/>
          <textarea-input v-model="form.message" class="pr-6 pb-8 w-full" label="Anniversary Message" :error="this.$page.props.errors.message"/>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!anniversary.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Anniversary Message</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update Anniversary Message</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import TextareaInput from '../../Shared/TextareaInput.vue'
import BadgePreview from '@/Shared/BadgePreview.vue'

export default {
  metaInfo() {
    return {
      title: `${this.form.anniversary} months`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    TextareaInput,
    BadgePreview,
  },
  layout: Layout,
  props: {
    anniversary: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        id: this.anniversary.id,
        anniversary: this.anniversary.anniversary,
        message: this.anniversary.message,
      })
    }
  },
  methods: {
    update() {
      this.form.put(this.route('anniversaries.update', this.anniversary.id))
    },
    destroy() {
      if (confirm('Are you sure you want to delete this Twitch Sub Anniversary message?')) {
        this.$inertia.delete(this.route('anniversaries.destroy', this.anniversary.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this Twitch Sub Anniversary message?')) {
        this.$inertia.put(this.route('anniversaries.restore', this.anniversary.id))
      }
    },
  },
}
</script>
